import * as yup from 'yup'

export const AutocompleteValueSchema = yup.object({
  id: yup.string(),
  text: yup.string(),
})

export const LaneSchema = yup.object({
  /**
   * @example { id: '123', text: 'Miami, FL' }
   */
  pickup: AutocompleteValueSchema.nullable().required('Pickup is required'),
  /**
   * @example 50
   */
  pickupRadius: yup.number().required('Pickup radius is required'),
  /**
   * @example { id: '456', text: 'Austin, TX' }
   */
  dropoff: AutocompleteValueSchema.nullable(),
  /**
   * @example 25
   */
  dropoffRadius: yup
    .number()
    .when('dropoff', {
      is: val => val !== null,
      then: yup.number().required('Dropoff radius is required'),
    })
    .nullable(),
})

export type TLaneSchema = yup.InferType<typeof LaneSchema>
